import React from 'react'
import { useRouter } from 'next/router'
import { NavItem } from '@chegg-wt/core/types/core'
import AppLink from '../AppLink'
import { useRoutesContext } from '../RoutesContext'
import * as Styled from './styled'

interface HeaderNavProps {
  navItems: NavItem[]
  style: string
  projectId: string
  onClick: (label: string) => void
  isWritingAssistantHomeEnabled?: boolean
}

export const HeaderNav: React.FC<HeaderNavProps> = ({
  navItems,
  style,
  projectId,
  onClick,
  isWritingAssistantHomeEnabled,
}) => {
  const routes = useRoutesContext()
  const router = useRouter()
  const routeParams = { projectId, style }

  return (
    <>
      {navItems.map((navItem) => {
        const navRoute = navItem.route
          ? routes[navItem.route](routeParams)
          : { href: navItem.href }

        return (
          <AppLink route={navRoute} key={navItem.href || navItem.name}>
            <Styled.HeaderNavLink
              data-test={`${navItem.name}-nav-link`}
              hideOnMobile={navItem.hideOnMobile}
              isActive={router.pathname === navRoute.href}
              onClick={() => onClick(navItem.name)}
              isWritingAssistantHomeEnabled={isWritingAssistantHomeEnabled}
            >
              {navItem.name}
            </Styled.HeaderNavLink>
          </AppLink>
        )
      })}
    </>
  )
}
